module.exports = __webpack_public_path__ + "static/media/kuaikeduo.f9556e70.jpg";